import callAPI from "config/callAPI";
import PortalAuth from "config/auth/PortalAuth";
import { setPortalActiveMenu } from "libraries/common_functions";

import React from "react";

import PortalHeader from "pages/portal/includes/PortalHeader";
import PortalMobileMenu from "pages/portal/includes/PortalMobileMenu";
import PortalTopMenu from "pages/portal/includes/PortalTopMenu";
import PortalFooter from "pages/portal/includes/PortalFooter";

const ENDPOINT = process.env.REACT_APP_BACKEND_URL + '/create_shortened_url';

class PortalShortenURL extends React.Component {
    constructor(){
        super();
        this.state = {
            isloggedin: false,
            alertColor: '',
            rstatus: '',
            rmessage: '',
            rdata: []
        } 

        let isloggedinPromise = PortalAuth();
        
        isloggedinPromise.then((isloggedin) => {
            this.setState({isloggedin: isloggedin});
        });
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        let data = Object.fromEntries(new FormData(e.target));

        const {rstatus, rmessage, rdata } = await callAPI(ENDPOINT, data); 
        this.setState({
            rstatus: rstatus,
            rmessage: rmessage,
            rdata: rdata
        });
        
        if (rstatus === true){ 
            if (rdata.url_id !== null && rdata.url_id !== undefined){
                window.location = '/portal/url/details?id=' + rdata.url_id;
            }
            this.setState({alertColor: 'green'}); 
        } 
        else if (rstatus === false) { 
            this.setState({alertColor: 'red'}); 
        }
    }

    componentDidMount(){
        setPortalActiveMenu('short_url');
    }

    render() {
        if (!this.state.isloggedin){
            return (<></>);
        }

        return (
            <>
                <PortalMobileMenu />

                <div className="flex">
                    
                    <PortalHeader />

                    <div className="content">
                            
                        <PortalTopMenu page_name="Create URL" />

                        <div className="intro-y flex items-center mt-8">
                            <h2 className="text-lg font-medium mr-auto">
                                Create Shortened URLs
                            </h2>
                        </div>

                        <div className="grid grid-cols-12 gap-6 mt-5">
                            <div className="intro-y col-span-12 lg:col-span-12">
                                <div className="intro-y box mt-5">
                                    <div className="p-5" id="horizontal-form">
                                        <form className="preview" onSubmit={event => this.handleSubmit(event)} method="post">
                                            <div className="flex flex-col sm:flex-row items-center">
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-3">
                                                    <label className="w-full sm:w-20 sm:text-right sm:mr-5">Campaign Name</label>
                                                    <input type="text" name="campaign_name" className="input w-full border mt-2 flex-1" placeholder="Enter campaign name" />
                                                </div>
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-3">
                                                    <label className="w-full sm:w-20 sm:text-right sm:mr-5">Destination URL</label>
                                                    <input type="text" name="url_to_shorten" className="input w-full border mt-2 flex-1" placeholder="Enter URL to shorten" />
                                                </div>
                                            </div>
                                            <div className="flex flex-col sm:flex-row items-center">
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-3">
                                                    <label className="w-full sm:w-20 sm:text-right sm:mr-5">UTM Source (optional)</label>
                                                    <input type="text" name="utm_source" className="input w-full border mt-2 flex-1" placeholder="Enter UTM source" />
                                                </div>
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-3">
                                                    <label className="w-full sm:w-20 sm:text-right sm:mr-5">Need to Track?</label>
                                                    <select name="need_to_track" className="input w-full border mt-2 flex-1" defaultValue={1} >
                                                        <option value="1">Yes</option>
                                                        <option value="0">No</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="flex flex-col sm:flex-row items-center mt-5">
                                                <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5">
                                                    <button type="submit" className="button bg-theme-1 text-white w-1/4">Create</button>
                                                </div>
                                            </div>
                                        </form>
                                        { this.state.rstatus !== '' ?
                    
                                            <p className="ml-5" style={{ color: this.state.alertColor, paddingTop: "10px"}}>
                                                {this.state.rmessage}
                                            </p>
                            
                                            : ""
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        
                    </div>
                </div>

                <PortalFooter />
            </>
        );
    }
}

export default PortalShortenURL;
